import { render } from "./HeroiconsOutlineTrendingUp.vue?vue&type=template&id=34545f94"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTrendingUp.vue"]])

export default __exports__